import React from 'react';

interface WifiConnectionOnIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
}

/**
 * Wifi connection on icon — a full wifi signal.
 *
 * Shown on the back-online connection bar (Figma node 16924:258081). Stroke colour
 * defaults to `currentColor`, so the parent's text colour drives the tint, and can
 * be overridden via `color`; `size` defaults to 22.4 to match the Figma artwork.
 * @param props - Standard icon props: `size`, `color` and any SVG attribute.
 * @returns The wifi-on icon SVG.
 */
const WifiConnectionOnIcon = ({
  size = 22.4,
  color = 'currentColor',
  ...restProps
}: WifiConnectionOnIconProps): React.ReactElement => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22.4 22.4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...restProps}
    >
      <path
        d="M4.66659 11.7136C6.51139 10.177 8.83636 9.33558 11.2373 9.33558C13.6382 9.33558 15.9631 10.177 17.8079 11.7136M1.32526 8.40026C4.05286 5.99596 7.56394 4.6694 11.1999 4.6694C14.8359 4.6694 18.347 5.99596 21.0746 8.40026M7.96126 15.0363C8.90878 14.3631 10.0423 14.0014 11.2046 14.0014C12.3669 14.0014 13.5004 14.3631 14.4479 15.0363M11.1999 18.6669H11.2093"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default React.memo(WifiConnectionOnIcon);
